import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { SITE } from "@/lib/site";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/inventory", label: "Inventory" },
  { to: "/performance", label: "Performance" },
  { to: "/financing", label: "Financing" },
  { to: "/gallery", label: "Gallery" },
  { to: "/contact", label: "Contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="fixed top-0 z-50 w-full border-b border-white/10 bg-black/60 backdrop-blur-xl" data-testid="site-header">
      <div className="mx-auto flex h-20 max-w-[1600px] items-center justify-between px-6 md:px-10">
        <Link to="/" className="group flex items-center gap-3" data-testid="nav-logo">
          <span className="font-display text-3xl font-black tracking-tight text-white transition-colors duration-300 group-hover:text-trx-blue">
            TRX
          </span>
          <span className="hidden sm:block text-[10px] font-semibold uppercase tracking-[0.3em] text-zinc-500 leading-tight">
            Auto Sales &<br />Service Inc
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-9" data-testid="nav-links">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `link-underline text-xs font-semibold uppercase tracking-[0.2em] transition-colors duration-300 ${
                  isActive ? "text-white active" : "text-zinc-400 hover:text-white"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-5">
          <a
            href={SITE.phoneHref}
            data-testid="nav-phone"
            className="flex items-center gap-2 text-xs font-semibold tracking-wider text-zinc-400 transition-colors duration-300 hover:text-white"
          >
            <Phone className="h-3.5 w-3.5" />
            {SITE.phone}
          </a>
          <Link
            to="/service"
            data-testid="nav-schedule-service"
            className="bg-trx-blue px-6 py-3 text-xs font-bold uppercase tracking-[0.2em] text-white transition-all duration-300 hover:bg-white hover:text-black"
          >
            Schedule Service
          </Link>
        </div>

        <button
          className="lg:hidden text-white"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-white/10 bg-black/95 backdrop-blur-xl" data-testid="nav-mobile-menu">
          <div className="flex flex-col px-6 py-6 gap-5">
            {LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `font-display text-2xl font-bold tracking-tight ${isActive ? "text-trx-blue" : "text-white"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/service"
              onClick={() => setOpen(false)}
              data-testid="nav-mobile-schedule"
              className="mt-2 bg-trx-blue px-6 py-4 text-center text-xs font-bold uppercase tracking-[0.2em] text-white"
            >
              Schedule Service
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};
